module.exports = __webpack_public_path__ + "static/lead-capture-via-web-sms-social-media-5fb1f7fb357deccaa67726e0a503f125.svg";